var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStageTheatre14644630(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "m21.5,0H2.5C1.122,0,0,1.121,0,2.5v21.5h7v-.5c0-4.256-2.254-6.785-3.475-7.843,2.027-.85,6.904-3.576,8.475-10.496,1.571,6.919,6.448,9.646,8.475,10.496-1.221,1.058-3.475,3.587-3.475,7.843v.5h7V2.5c0-1.379-1.122-2.5-2.5-2.5ZM5.988,23H1v-7h1.346c.599.417,3.438,2.618,3.642,7Zm-3.557-8h-1.432V2.5c0-.827.673-1.5,1.5-1.5h2.975c-.126,2.651-1.212,4.729-2.475,5.933v1.244c1.699-1.309,3.321-3.757,3.471-7.176h2.012c-.179,5.074-3.023,8.183-5.483,9.62v1.131c2.789-1.473,6.29-4.858,6.482-10.75h1.996c-.241,11.131-8.203,13.756-9.046,14ZM12.522,1h1.996c.192,5.892,3.692,9.278,6.482,10.75v-1.131c-2.46-1.437-5.304-4.545-5.483-9.62h2.012c.15,3.42,1.772,5.867,3.471,7.176v-1.244c-1.264-1.204-2.349-3.281-2.475-5.933h2.975c.827,0,1.5.673,1.5,1.5v12.5h-1.432c-.843-.244-8.805-2.869-9.046-14Zm5.489,22c.206-4.429,3.105-6.631,3.662-7.014l1.326.01v7.004h-4.988Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStageTheatre14644630);
export default __webpack_public_path__ + "static/media/stage-theatre_14644630.542289a31406391f47cc65d3de52b14f.svg";
export { ForwardRef as ReactComponent };